class SmoothScroll {
  constructor(button) {
    this.button = button;
    this.targetId = this.button.getAttribute('href').substring(1);
    this.targetElement = document.getElementById(this.targetId);

    if (this.targetElement) {
      this.bindListener();
      this.observeTargetVisibility();
    }
  }

  scrollToTarget(event) {
    event.preventDefault();
    this.targetElement.scrollIntoView({ behavior: 'smooth' });
  }

  bindListener() {
    this.button.addEventListener('click', (event) => this.scrollToTarget(event));
  }

  observeTargetVisibility() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.button.classList.add('hide');
          } else {
            this.button.classList.remove('hide');
          }
        });
      },
      {
        root: null,
        threshold: 0.2,
      }
    );

    observer.observe(this.targetElement);
  }
}

const contactButtons = document.querySelectorAll('.js-contact-btn');

if (contactButtons) {
  contactButtons.forEach(button => {
    new SmoothScroll(button);
  });
}
